import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=20a1c285"
import script from "./EditJob.vue?vue&type=script&lang=ts"
export * from "./EditJob.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports